/** NOTIF1 T13: bell, popover, /notifications copy. */
export const INBOX_COPY = Object.freeze({
  title: 'Notifications',
  bell: 'Notifs',
  bellLabel: (count, unread) => {
    if (count) return `Notifications, ${count} action${count > 1 ? 's' : ''} à traiter`;
    if (unread) return `Notifications, ${unread} non lue${unread > 1 ? 's' : ''}`;
    return 'Notifications';
  },
  markAllRead: 'Tout marquer comme lu',
  seeAll: 'Tout voir',
  toHandle: 'À traiter',
  activity: 'Activité',
  emptyActions: 'Rien à traiter.',
  emptyEvents: 'Aucune activité pour le moment.',
  loadMore: 'Charger plus',
  loading: 'Chargement…',
  loadError: 'Impossible de charger les notifications.',
  unread: 'Non lu',
  today: 'Aujourd’hui',
  yesterday: 'Hier',
  filtersLabel: 'Filtrer',
  filters: { tout: 'Tout', annulations: 'Annulations', demandes: 'Demandes', paiements: 'Paiements', urssaf: 'URSSAF' },

  accept: 'Accepter',
  refuse: 'Refuser',
  later: 'Plus tard',
  laterOption: (days) => (days === 1 ? 'Demain' : days === 7 ? 'Dans 1 semaine' : `Dans ${days} jours`),
  dismiss: 'Masquer',
  seen: 'Vu',
  done: 'Fait',
  open: 'Ouvrir',
  openAgenda: 'Ouvrir l’agenda',
  declare: 'Déclarer',
  view: 'Voir',
  retry: 'Réessayer',
  reschedule: 'Reprogrammer',
  refuseConfirm: {
    title: 'Refuser la demande ?',
    message: (family) => `La famille ${family} recevra un e-mail tout de suite.`,
    confirm: 'Refuser',
    cancel: 'Annuler',
  },
  decided: { approve: 'Demande acceptée.', reject: 'Demande refusée.' },
  conflict: 'Cette demande vient d’être traitée ailleurs. La liste est à jour.',
  snoozed: 'Reportée.',
  dismissed: 'Masquée.',
  error: 'Action impossible. Réessayez.',

  chips: {
    tomorrow: 'Demain',
    weekly: (day) => `Chaque ${day.toLowerCase()}`,
    urgent: 'Urgent',
    decision: 'Décision',
    before: (date) => `Avant le ${date}`,
    approved: 'Acceptée',
    rejected: 'Refusée',
    expired: 'Expirée',
  },

  actions: {
    cancellation_request: {
      title: 'Annulation demandée',
      meta: (p) => [p.student_first_name, p.family_last_name && `famille ${p.family_last_name}`, p.when, p.subject]
        .filter(Boolean).join(' · '),
    },
    lesson_request: {
      title: 'Demande de cours',
      meta: (p) => [p.student_first_name, p.family_last_name && `famille ${p.family_last_name}`,
        p.preferred_slots && `« ${p.preferred_slots} »`].filter(Boolean).join(' · '),
    },
    schedule_conflict: {
      title: 'Conflit de planning',
      meta: (p) => `${p.day} : ${p.name_a} ${p.start_a} et ${p.name_b} ${p.start_b} se chevauchent`,
    },
    urssaf_declaration: { title: (p) => p.title || 'Déclaration URSSAF', meta: (p) => p.desc || '' },
    urssaf_payment_issue: {
      title: 'Avance immédiate refusée par l’URSSAF',
      meta: (p) => [p.family_name, p.urssaf_libelle].filter(Boolean).join(' · '),
    },
    suggestion: { title: (p) => p.title || '', meta: (p) => p.desc || '' },
    urssaf_demand_retry: {
      title: 'Réessayer la demande d’Avance Immédiate',
      meta: (p) => `${(p.lesson_ids || []).length} séance(s) à replacer après l’activation URSSAF`,
    },
  },

  /** Feed sentences; `others` = extra families grouped the same day. */
  events: {
    lesson_request: 'demande un cours',
    cancel_request: 'demande l’annulation d’un cours',
    ai_sent: 'a envoyé une avance immédiate',
    ai_cap: 'a atteint la limite d’avance immédiate',
    ai_failed: 'n’a pas pu envoyer son avance immédiate',
    ai_children: 'a modifié le nombre d’enfants déclarés',
    identity_email: 'a modifié son e-mail',
    memo_set: 'a ajouté un mémo de date',
    data_deletion_request: 'demande la suppression de ses données',
  },
  /** N30 rows: no actor sentence; the actor is added only when it is not the reader. */
  registered: {
    lesson_registered: (when) => `Séance du ${when} enregistrée`,
    payment_registered: (amount) => `Paiement de ${amount} enregistré`,
    lesson_deleted: (when) => `Séance du ${when} supprimée`,
    lesson_cancelled: (when) => `Séance du ${when} annulée`,
    payment_cancelled: (amount) => `Paiement de ${amount} annulé`,
    payment_updated: (when) => `Paiement du ${when} modifié`,
    session_skipped: (when) => `Séance du ${when} annulée`,
    session_moved: (when) => `Séance du ${when} déplacée`,
    urssaf_validation_pending: () => 'Avance Immédiate à valider : ouvrez l’e-mail de l’URSSAF et activez le compte',
    urssaf_demand_retry: () => 'Rappel programmé : réessayer la demande d’Avance Immédiate demain à 8 h',
    byFamily: (name) => (name ? ` par la famille ${name}` : ' par la famille'),
    byUrssaf: ' par l’URSSAF (avance immédiate)',
    byTeacher: ' par votre professeur',
    forStudent: (name) => ` pour ${name}`,
    forFamily: (name) => ` pour la famille ${name}`,
  },
  familyTitle: (name) => name ? `Famille ${name}` : '',
  browser: {
    title: 'NeoProf',
    toggle: 'Notifications du navigateur',
    hint: 'Une alerte quand une famille agit, tant qu’un onglet NeoProf est ouvert.',
    denied: 'Notifications bloquées par le navigateur. Autorisez-les dans les réglages du site (icône à gauche de l’adresse), puis rechargez la page.',
    unsupported: 'Ce navigateur ne gère pas les notifications.',
  },
  eventFallback: 'a fait une action',
  familyFallback: 'Une famille',
  others: (count) => ` et ${count} autre${count > 1 ? 's' : ''} famille${count > 1 ? 's' : ''}`,
  agenda: {
    cancelChip: 'Annulation demandée',
    conflictChip: 'Conflit',
    requestsLane: 'Demandes de cours',
    requestTitle: 'Demande d’annulation',
    reason: (text) => `« ${text} »`,
    noReason: 'Aucun motif donné.',
    family: (name) => `Famille ${name}`,
    slots: (text) => `Disponibilités : « ${text} »`,
    acceptAndPlan: 'Accepter et planifier',
    conflictsAfterSave: 'Ce créneau chevauche un autre cours.',
  },
  amount: (value) => `${Number(value).toFixed(2).replace('.', ',')} €`,
});
